<template>
  <ext-form @submitSuccess="$emit('submitSuccess')" :formData="formData" :submitProxy="proxy" submitBtnText="Регистрация">
    <b-form-fieldset
      label="Логин"
      :feedback = "errors.first('login')"
      :class="{'is-invalid': errors.has('login') }"
    >
      <input class="form-control" v-validate="'required|eng'" v-model.trim="formData.login"  name="login"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Пароль"
      :feedback = "errors.first('password')"
      :class="{'is-invalid': errors.has('password') }"
    >
      <input class="form-control" name="password" type="password" v-model="formData.password" v-validate="'required'">
    </b-form-fieldset>
    <b-form-fieldset
      label="Пароль повторно"
      :class="{'is-invalid': errors.has('password2') }"
      feedback = "Пароли не совпадают"
    >
      <input class="form-control" name="password2" type="password" v-model="formData.replyPassword" v-validate="'confirmed:password|required'">
    </b-form-fieldset>
  </ext-form>
</template>

<script>
import ExtForm from '@/components/ExtForm'

export default {
  components: {
    ExtForm
  },
  data () {
    return {
      formData: {
        login: '',
        password: '',
        replyPassword: ''
      },
      proxy: {
        url: 'api/user',
        method: 'put'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreateAccountForm.vue?14e2b546